import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'app/core/material_modules/material.module';
import { DateRangeComponent } from './date-range.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    DateRangeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule
  ],
  exports:[
    DateRangeComponent
  ],
  providers:[]
})
export class DateRangeModule { }
